const SIZE_LIST = {
  1: 'XS',
  2: 'S',
  3: 'M',
  4: 'L',
  5: 'XL',
  6: 220,
  7: 230,
  8: 240,
  9: 250,
  10: 260,
  11: 270,
  12: 280,
  13: 290,
  14: 300,
  15: 'FREE',
};

export default SIZE_LIST;
